import { createContext } from "react";

const QuestionnairesContext = createContext({});

export default QuestionnairesContext;
